import { useMemo, useRef, useState } from 'react';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import LinearGradient from '@hfe/max-linear-gradient';
import { venusParams } from '../../utils/formatImage';
import { Free_Travel_TAG, GROUP_TOUR_TAG } from '../../utils/constants';
import { formatPrice } from '../../utils/formatPrice';
import { jumpToDetail } from '../../utils/jumpUtils';
import { useEffect, createElement } from '@max/max';
const isMRN = false;
import { getSystemInfoSync } from '@max/meituan-uni-system';
import ImageBackground from '@hfe/max-imagebackground';
import Sensor from '@max/mbc-sensor';
import './index.scss';
import { isWeb } from '@msi/channel-basic';
const ThreeColumnsCard = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { goodInfo, index, supplyGroupId, pageSourceType, _LXReport, isShowChoiceness, customTagConfig } = props;
    const { platform } = getSystemInfoSync() || {};
    const isAndroid = platform === 'android';
    const tagContainerRef = useRef(null); // 优惠标签,用于h5获取宽度
    const [tagContainerWidth, setTagContainerWidth] = useState(0);
    const { mvReport, mcReport } = _LXReport;
    const jumpDetail = () => {
        jumpToDetail({
            goodInfo,
            index,
            supplyGroupId,
            pageSourceType,
            mcReport
        });
    };
    const handleView = () => {
        mvReport('b_daodian_lowcode_7s2beos5_mv', {
            valLab: {
                deal_id: goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.goodsId,
                biz_line: 'holiday',
                dealgroup_id: supplyGroupId,
                item_index: index
            }
        });
    };
    // 格式化促销金额，处理异常格式如 ' .00 '
    const formatPromotionAmount = (amount) => {
        if (!amount)
            return '0';
        // 如果是字符串，先去除空格
        const cleanAmount = typeof amount === 'string' ? amount.trim() : amount;
        // 处理以点开头的情况，如 '.00'
        const normalizedAmount = String(cleanAmount).replace(/^\s*\./, '0.');
        // 转换为数字
        const numAmount = Number(normalizedAmount);
        // 如果是非法数字，返回0
        if (isNaN(numAmount))
            return '0';
        // 如果是整数，直接返回
        if (Number.isInteger(numAmount))
            return String(numAmount);
        // 保留两位小数，去除末尾的0
        return numAmount.toFixed(2).replace(/\.?0+$/, '');
    };
    const calcFontSize = (str) => {
        if (str.length <= 3) {
            return '36rpx';
        }
        else if (str.length === 4) {
            return '32rpx';
        }
        else if (str.length === 5) {
            return '26rpx';
        }
        else {
            return '20rpx';
        }
    };
    const getTagTextWidth = (tagText) => {
        let fontSize = 20;
        let width = 0;
        for (let i = 0; i < (tagText === null || tagText === void 0 ? void 0 : tagText.length); i++) {
            const char = tagText[i];
            // 中文字符、全角字符占用更多空间
            if (/[\u4e00-\u9fa5]|[\uFF00-\uFFEF]/.test(char)) {
                width += fontSize;
            }
            else {
                width += fontSize * 0.6;
            }
        }
        return width || 0;
    };
    const handleTagContainerLayout = (event) => {
        var _a, _b;
        let width = (_b = (_a = event === null || event === void 0 ? void 0 : event.nativeEvent) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.width;
        setTagContainerWidth(width);
    };
    const getH5TagContainerWidth = () => {
        var _a;
        let width = (_a = tagContainerRef === null || tagContainerRef === void 0 ? void 0 : tagContainerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth;
        setTagContainerWidth(width);
    };
    const getH5DiscountWidth = () => {
        var _a;
        // 根据文本获取宽度
        let discountText = `共省¥${formatPromotionAmount((_a = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _a === void 0 ? void 0 : _a.promotionAmount)}`;
        const width = getTagTextWidth(discountText);
        return width;
    };
    const getOneServiceTag = () => {
        let remainWidth = 0;
        // 根据优惠标签文本获取宽度
        const discountWidth = getH5DiscountWidth();
        if (tagContainerWidth !== 0) {
            // 剩余宽度
            remainWidth = (tagContainerWidth - discountWidth) * 2;
            const tagWidths = productTag.map((item) => {
                return getTagTextWidth(item);
            });
            // 要从这个数组种取出小于剩余宽度的索引
            const index = tagWidths.findIndex((item) => item < remainWidth);
            if (index === -1) {
                return [];
            }
            return [productTag[index]];
        }
        return [];
    };
    const getServicTag = () => {
        if (tagContainerWidth !== 0) {
            const firstWidthTextWidth = getTagTextWidth(productTag[0]);
            const remainWidth = (tagContainerWidth - firstWidthTextWidth) * 2;
            const tagArrs = productTag.map((item) => {
                return getTagTextWidth(item);
            });
            const index = tagArrs.findIndex((item) => item < remainWidth);
            if (index === -1) {
                return [productTag[0]];
            }
            // 默认都一个展示，省下一个由文本长度决定
            return [productTag[0], productTag[index]];
        }
        return [];
    };
    const actualPrice = (_b = (_a = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _a === void 0 ? void 0 : _a.payPrice) !== null && _b !== void 0 ? _b : goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.sellPrice;
    const categoryTagKey = (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) === '跟团游' ? 3 : 2;
    const categoryTag = (_d = (_c = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.tags) === null || _c === void 0 ? void 0 : _c.find((item) => (item === null || item === void 0 ? void 0 : item.tagKey) === categoryTagKey)) === null || _d === void 0 ? void 0 : _d.descriptions;
    // 通用标签
    const productTag = (_f = (_e = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.tags) === null || _e === void 0 ? void 0 : _e.find((item) => (item === null || item === void 0 ? void 0 : item.tagKey) === 1)) === null || _f === void 0 ? void 0 : _f.descriptions;
    const priceTagCount = useMemo(() => {
        var _a, _b, _c;
        return ((_a = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _a === void 0 ? void 0 : _a.promotionAmount) && ((_b = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _b === void 0 ? void 0 : _b.promotionAmount) !== '0.00' && Number((_c = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _c === void 0 ? void 0 : _c.promotionAmount) ? 1 : 0;
    }, [(_g = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _g === void 0 ? void 0 : _g.promotionAmount]);
    const showProductTag = useMemo(() => {
        if (priceTagCount === 0) {
            return getServicTag();
        }
        if (priceTagCount === 1) {
            return getOneServiceTag();
        }
    }, [categoryTag, productTag, priceTagCount, tagContainerWidth]);
    useEffect(() => {
        handleView();
    }, []);
    useEffect(() => {
        if (isWeb) {
            getH5TagContainerWidth();
        }
    }, []);
    return <View className="three-card-container-three" onClick={() => {
        jumpDetail();
    }}>
            <View className="three-card-image-view">
                <Image className="three-card-image" source={{
        uri: venusParams(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.goodsHeadPhoto, 226, 170)
    }}/>
            </View>
            {isShowChoiceness === 1 && customTagConfig.customTagCount > 0 && index <= customTagConfig.customTagCount - 1 ? <ImageBackground source={{
        uri: customTagConfig.customTagBgUrl
    }} className="three-card-custom-tag-bg" style={{
        paddingTop: isAndroid ? '4rpx' : '0rpx'
    }}>
                        <Text className="three-card-custom-tag-text">{customTagConfig.customTagText}</Text>
                    </ImageBackground> : <></>}

            {isShowChoiceness !== 1 && <>
                    <Image className="three-card-image-tag" source={{
        uri: (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) === '跟团游' ? GROUP_TOUR_TAG : Free_Travel_TAG
    }}/>
                    {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) === '跟团游' && (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.departures) && goodInfo.departures.length > 0 && <View className="three-departures-container">
                            <LinearGradient className="three-departures-background" start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }} colors={['rgba(51, 51, 51, 0.6)', 'rgba(51, 51, 51, 0.6)']} style={{
        borderBottomRightRadius: 10
    }}/>
                            <Text className="three-departures-text">
                                {goodInfo.departures.length > 1 ? '多地出发' : `${((_h = goodInfo.departures[0]) === null || _h === void 0 ? void 0 : _h.cityName) || 'X X '}出发`}
                            </Text>
                        </View>}</>}

            <View className="three-card-content-right">
                <View className="three-card-top-field">
                    <View className="three-card-tag-field">
                        <View className="three-card-deal-name">
                            <View className="three-card-day-h5-tag-view" style={{
        top: isMRN ? '-2rpx' : '-2rpx',
        left: isMRN ? '-4rpx' : '3rpx'
    }}>
                                <Text className="three-card-day-h5-tag-text">{goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.travelDay}</Text>
                            </View>
                            <Text className="three-card-deal-name-text" numberOfLines={2}>{isMRN ? '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0' : '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'}{goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.goodsName}
                            </Text>
                        </View>
                    </View>
                    <Sensor onLayout={event => handleTagContainerLayout(event)}>
                        <View className="three-card-tag" ref={tagContainerRef}>
                            {priceTagCount === 1 && <View className="three-card-product-tag-price">
                                    <Text className="three-card-product-tag-text-price">{`共省¥${formatPromotionAmount((_j = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _j === void 0 ? void 0 : _j.promotionAmount)}`}</Text>
                                </View>}
                            {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) === '跟团游' && (showProductTag === null || showProductTag === void 0 ? void 0 : showProductTag.map((item) => {
        return <View className="three-card-product-tag-group">
                                            <Text className="three-card-product-tag-text-group">{item}</Text>
                                        </View>;
    }))}
                            {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) !== '跟团游' && (categoryTag === null || categoryTag === void 0 ? void 0 : categoryTag.map((item) => {
        return <View className="three-card-people-tag">
                                            <Text className="three-card-people-tag-text">{item}</Text>
                                        </View>;
    }))}
                            {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) !== '跟团游' && (showProductTag === null || showProductTag === void 0 ? void 0 : showProductTag.map((item) => {
        return <View className="three-card-product-tag-free">
                                            <Text className="three-card-product-tag-text-free">{item}</Text>
                                        </View>;
    }))}
                        </View>
                    </Sensor>
                </View>

                <View className="three-card-bottom-field">
                    <View className="three-card-bottom-left-field">
                        <View className="three-card-price-now" style={{
        marginBottom: isAndroid ? '3rpx' : '0rpx'
    }}>
                            <Text className="three-card-price-icon">¥</Text>
                            <Text className="three-card-price-price" style={{
        marginBottom: isAndroid ? '-2rpx' : '-5rpx',
        fontFamily: 'MTNewDigitalDisplay-Bold',
        fontSize: calcFontSize(formatPrice(actualPrice))
    }}>
                                {formatPrice(actualPrice)}
                            </Text>
                            <Text className="three-card-price-start">起</Text>
                        </View>
                    </View>
                    <View className="three-card-bottom-right-field-container">
                        <View className="three-card-bottom-right-field">
                            <LinearGradient start={{
        x: 0.067,
        y: 0.75
    }} end={{
        x: 0.933,
        y: 0.25
    }} colors={['#FF7700', '#FF4B10']} style={{
        height: '48rpx',
        width: '84rpx',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }}>
                                <Text className="three-card-bottom-right-text">{'抢购'}</Text>
                            </LinearGradient>
                        </View>
                    </View>

                </View>
            </View>
        </View>;
};
export default ThreeColumnsCard;
